const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  mediaGalleryLoaded: 'media-gallery-loaded',
  cartProductsLoaded: 'cart-products-loaded',
  userLocationUpdated: 'user-location-updated',
  cartDataLoaded: 'cart-data-loaded'
};

const USER_LOCATION_STORAGE = {
  postcode: 'user_postcode',
  suburb: 'user_suburb',
  state: 'user_state',
  userSetLocation: 'user_set_location',
  userSetGeolocation: 'user_set_geolocation',
  longitude: 'user_longitude',
  latitude: 'user_latitude',
  geolocationCode: 'user_geolocation_code', //should not be affected by shipping location changes
};

const REGION_LOCATIONS = [
  {
    id: '000001',
    suburb: 'SYDNEY',
    state: 'NSW',
    postcode: '2000'
  },
  {
    id: '000002',
    suburb: 'MELBOURNE',
    state: 'VIC',
    postcode: '3000'
  },
  {
    id: '000003',
    suburb: 'BRISBANE',
    state: 'QLD',
    postcode: '4000'
  },
  {
    id: '000004',
    suburb: 'ADELAIDE',
    state: 'SA',
    postcode: '5000'
  },
  {
    id: '000005',
    suburb: 'CANBERRA',
    state: 'ACT',
    postcode: '2600'
  },
  {
    id: '000006',
    suburb: 'DARWIN CITY',
    state: 'NT',
    postcode: '800'
  },
  {
    id: '000088',
    suburb: 'BRISBANE',
    state: 'QLD',
    postcode: '4000'
  }
]
CITY_CENTRES = [
  {
    code: 'sydney',
    suburb: 'SYDNEY',
    state: 'NSW',
    postcode: '2000',
    coordinates_suburb: 'LIDCOMBE',
    coordinates_state: 'NSW',
    coordinates_postcode: '2141',
    longitude: 151.043626,
    latitude: -33.864691,
    radius: 40
  },
  {
    code: 'melbourne',
    suburb: 'MELBOURNE',
    state: 'VIC',
    postcode: '3000',
    coordinates_suburb: 'GLEN IRIS',
    coordinates_state: 'NSW',
    coordinates_postcode: '3146',
    longitude: 145.063187,
    latitude: -37.857060,
    radius: 40
  },
  {
    code: 'brisbane',
    suburb: 'BRISBANE',
    state: 'QLD',
    postcode: '4000',
    coordinates_suburb: 'BRISBANE',
    coordinates_state: 'NSW',
    coordinates_postcode: '4000',
    longitude: 153.02654121878365,
    latitude: -27.470162785778097,
    radius: 50
  },
  {
    code: 'sunshinecoast',
    suburb: 'BRISBANE',
    state: 'QLD',
    postcode: '4000',
    coordinates_suburb: 'MAROOCHYDORE',
    coordinates_state: 'QLD',
    coordinates_postcode: '4558',
    longitude: 153.066666,
    latitude: -26.650000,
    radius: 20
  },
  {
    code: 'goldcoast',
    suburb: 'BRISBANE',
    state: 'QLD',
    postcode: '4000',
    coordinates_suburb: 'BUNDALL',
    coordinates_state: 'QLD',
    coordinates_postcode: '4217',
    longitude: 153.399994,
    latitude: -28.016666,
    radius: 30
  },
  {
    code: 'perth',
    suburb: 'PERTH',
    state: 'WA',
    postcode: '6000',
    coordinates_suburb: 'PERTH',
    coordinates_state: 'WA',
    coordinates_postcode: '6000',
    longitude: 115.857048,
    latitude: -31.953512,
    radius: 20
  },
  {
    code: 'perth',
    suburb: 'PERTH',
    state: 'WA',
    postcode: '6000',
    coordinates_suburb: 'PERTH',
    coordinates_state: 'WA',
    coordinates_postcode: '6000',
    longitude: 115.857048,
    latitude: -31.953512,
    radius: 20
  },
  {
    code: 'darwin',
    suburb: 'DARWIN CITY',
    state: 'NT',
    postcode: '800',
    coordinates_suburb: 'DARWIN CITY',
    coordinates_state: 'NT',
    coordinates_postcode: '800',
    longitude: 130.8410469,
    latitude: -12.46044,
    radius: 40
  },
  {
    code: 'adelaide',
    suburb: 'ADELAIDE',
    state: 'SA',
    postcode: '5000',
    coordinates_suburb: 'ADELAIDE',
    coordinates_state: 'SA',
    coordinates_postcode: '5000',
    longitude: 138.5999312,
    latitude: -34.9281805,
    radius: 40
  },
  {
    code: 'hobart',
    suburb: 'HOBART',
    state: 'TAS',
    postcode: '7000',
    coordinates_suburb: 'HOBART',
    coordinates_state: 'TAS',
    coordinates_postcode: '7000',
    longitude: 147.3281233,
    latitude: -42.8825088,
    radius: 40
  },
  {
    code: 'centralcoast',
    suburb: 'BAY VILLAGE',
    state: 'NSW',
    postcode: '2261',
    coordinates_suburb: 'BAY VILLAGE',
    coordinates_state: 'NSW',
    coordinates_postcode: '2261',
    longitude: 151.333876,
    latitude: -33.369587,
    radius: 33
  },
  {
    code: 'wollongong',
    suburb: 'WOLLONGONG',
    state: 'NSW',
    postcode: '2500',
    coordinates_suburb: 'PORT KEMBLA',
    coordinates_state: 'NSW',
    coordinates_postcode: '2505',
    longitude: 150.900170,
    latitude: -34.450900,
    radius: 42
  },
  {
    code: 'newcastle',
    suburb: 'NEWCASTLE',
    state: 'NSW',
    postcode: '2300',
    coordinates_suburb: 'KOTARA',
    coordinates_state: 'NSW',
    coordinates_postcode: '2289',
    longitude: 151.741704,
    latitude: -32.874937,
    radius: 44
  }
]
